import toPrice from './toPrice'

export default{
    toPrice
    
}